module.exports = __webpack_public_path__ + "static/media/Untitled-5.e968d51c.png";